const g = ({
  totalAdults: n,
  totalChildren: t,
  isChildrenAllowed: e,
  withDash: i = !0
}) => {
  const o = `${I18n.t(
    `booking_engine.information.adults.${n === 1 ? "one" : "other"}`,
    { count: n.toString() }
  )}`, r = `${i ? "- " : ""}${I18n.t(
    `booking_engine.information.children.${t === 1 ? "one" : "other"}`,
    { count: t.toString() }
  )}`;
  return e ? `${o} ${r}` : o;
};
export {
  g as getGuests
};
